import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import addressData from "../../data/addressData.json";

export default function PropertyDetailsViewTile({consumerData}) {
    const [yearSpanList, setYearSpanList] = useState([]);

    useEffect(() => {
        setYearSpanList(addressData.yearSpanConsumer);
    },[]);

    const getYearLabel = (value) => {
        return (yearSpanList && yearSpanList.length > 0 ) ? yearSpanList?.filter(x => x.value === Number(value))[0]?.label : '';
    };
    return (
        <>
            <Typography variant="h5" component="h2">
                Property Details
            </Typography>
            <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
                <Grid item xs={12} sm={6} md={4}>
                    Property Type<br/>
                    <b>{consumerData?.propertyTypeLabel}</b>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    Construction Type<br/>
                    <b>{consumerData?.constructionTypeLabel}</b>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    Year Built
                    <br/>
                    <b>{consumerData?.yearBuilt}</b>
                </Grid>
                {consumerData?.yearBuilt > 999 && <>
                    <Grid item xs={12} sm={6} md={4}>
                        Year Roof Updated
                        <br/>
                        <b>{getYearLabel(consumerData?.roof)}</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Year Electrical Updated
                        <br/>
                        <b>{getYearLabel(consumerData?.electrical)}</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Year Plumbing Updated
                        <br/>
                        <b>{getYearLabel(consumerData?.plumbing)}</b>
                    </Grid>
                </>}
                <Grid item xs={12} sm={6} md={4}>
                    Square Footage
                    <br/>
                    <b>{consumerData?.squareFootage}</b>
                </Grid>
            </Grid>
        </>
    );
}
